module.exports = __webpack_public_path__ + "static/media/noun_check.037bd768.svg";